<template>
    <div class="add-to-cart">
        <template v-if="product.canPurchaseByMember">
            <div v-if="product.VariableAmount" class="variable-price">
                <span>$</span><input type="number" :min="product.MinimumAmount > 5 ? product.MinimumAmount : 5" step=".01"
                                     v-model="userDefinedPrice" placeholder="Amount">
            </div>
            <template v-if="productAttribute('CurrentStock') > 0">
                <template v-if="product.ProductType != 'GiftVoucherProduct'" >
                    <v-select v-if="showQuantity" id="product-quantity"
                              v-model="quantitySelected"
                              :options="quantityOptions"
                              :clearable="false">
                    </v-select>
                    <button v-if="isButton" :disabled="disabled" class="btn shadow-light" :class="extraClasses" @click.prevent.stop="handleAdd()">
                        <i v-if="icon" class="fal" :class="icon" aria-hidden="true"></i>
                        <span v-if="buttonText">{{ buttonText }}</span>
                    </button>
                    <div class="link" v-else :class="extraClasses" @click.prevent.stop="handleAdd()">
                        <i v-if="icon" class="fal" :class="icon" aria-hidden="true"></i>
                        <span v-if="buttonText">{{ buttonText }}</span>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="tags">
                    <div class="tag beige"><p><span>Sold Out</span></p></div>
                </div>
            </template>

            <template v-if="showExpressOption && !disabled">
                <ExpressCart @trackadd="this.trackAdd" :product="product" :variation="variation" :price="parseFloat(userDefinedPrice)"/>
            </template>
        </template>
        <template v-else>
            <div class="tags" @click="emitLogin('showlogin')">
                <div class="tag beige"><p><span>Wine Club Exclusive</span></p></div>
            </div>
        </template>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ExpressCart from "./ExpressCart";

export default {
    name: "AddToCart",
    components: {
        ExpressCart,
    },
    data() {
        return {
            userDefinedPrice: this.product.MinimumAmount > 0 ? this.product.MinimumAmount : 5,
            quantitySelected: 1,
            quantityOptions: []
        }
    },
    props: {
        product: {type: Object},
        variation: {type: Object, required: false},
        isButton: {type: Boolean},
        showQuantity: {type: Boolean},
        showExpressOption: {type: Boolean},
        buttonText: {type: String},
        icon: {type: String},
        extraClasses: {type: String}
    },
    computed: {
        disabled() {
            //button is disabled if the product has variations and none has been selected
            return this.product.Variations.length > 0 && !this.variation;
        }
    },
    methods: {
        ...mapActions(['addToCart']),
        handleAdd() {
            if (!this.disabled && this.productAttribute('CurrentStock') > 0) {
                let quantity = this.quantitySelected > 1 ? this.quantitySelected : 1,
                    link = this.productAttribute('AddLink') + '&quantity=' + quantity;

                if (parseFloat(this.userDefinedPrice) > 0) {
                    link = link + '&UnitPrice=' + parseFloat(this.userDefinedPrice);
                }

                this.trackAdd();
                this.addToCart(link);
            }
        },
        trackAdd() {
            if (this.$gtm.enabled()) {
                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'currency': this.product.Currency,
                        'items': [{
                            'item_id': this.product.ID,
                            'item_name': this.productAttribute('Title'),
                            'price': this.productAttribute('LocalisedPrice'),
                            'item_category': this.productAttribute('ProductType'),
                            'quantity': this.quantitySelected
                        }]
                    }
                });
            }
        },
        productAttribute($attr) {
            if (this.variation && this.variation[$attr]) {
                return this.variation[$attr];
            }
            return this.product[$attr];
        },
        emitLogin(event) {
            // this.$emit(event);
            window.location.replace('https://www.gibbstonvalley.com/wine-club/login/');
        }
    },
    mounted() {
        let quantityLength = 60;

        if(this.product.MaxOrderQuantity && this.product.MaxOrderQuantity > 0) {
            quantityLength = this.product.MaxOrderQuantity;
        }

        this.quantityOptions = Array.from(Array(quantityLength).keys(), n => n + 1);
    }
}
</script>
